module.exports = __webpack_public_path__ + "media/images/safe-contractor-52af6d766ca1a875fdaaf977ae36e5e6.png";